import styled from "styled-components";

import {
  DATA_E2E_KEY,
  DRAG_HANDLE_WIDTH,
  IStyledAttributes,
} from "@ryde/shared";
import { greyMui, ScreenDepth } from "@ryde/theme";

export const SplitterStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "grid-splitter",
})`
  background-color: ${greyMui._300};
  cursor: col-resize;
  width: ${DRAG_HANDLE_WIDTH}px;
  height: 100%;
  user-select: none;
  z-index: ${ScreenDepth.GRID_SPLITTER};
  position: relative;

  &:hover {
    background-color: ${greyMui._400};
  }
`;
